import { CORE_EVENTS, AUTH_EVENTS, TAP_EVENTS } from './contants';

export const MAIN_TO_GOOGLE_CONVERSION_EVENTS = {
  [AUTH_EVENTS.signUp]: '1to7CN3G5IAYENmd_oIp',
  [CORE_EVENTS.startGame]: 'pvuECNf_4oAYENmd_oIp',
  [CORE_EVENTS.twoGames]: 'DfmPCIeJ44AYENmd_oIp',
  [CORE_EVENTS.fiveGames]: 'JjkKCIqJ44AYENmd_oIp',
  [CORE_EVENTS.tenGames]: 'Ci4vCI2J44AYENmd_oIp',
  [TAP_EVENTS.deeplink]: 'wPHtCJPaq5QYENmd_oIp',
} as const;

type GoogleConversionEvent = typeof MAIN_TO_GOOGLE_CONVERSION_EVENTS[keyof typeof MAIN_TO_GOOGLE_CONVERSION_EVENTS];

class GoogleConversion {
  public trackEvent(name: GoogleConversionEvent) {
    if (!window.gtag) {
      console.log('GTAG is undefined, unable to send conversion events :(');
      return false;
    }

    window.gtag('event', 'conversion', {
      send_to: `AW-11012116185/${name}`,
      event_callback: () => {},
    });

    return false;
  }
}

export default GoogleConversion;
